import axios from '../utils/axios';

const base = '/ai-public';

export const aiPublicApi = {
  chat: (message, history = []) =>
    axios.post(`${base}/chat`, { message, history }).then((r) => r.data.data),

  chatStream: async function* (message, history = []) {
    const API_URL = process.env.REACT_APP_API_URL || 'https://api.tauris.io/api';

    const response = await fetch(`${API_URL}${base}/chat/stream`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message, history }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed || !trimmed.startsWith('data: ')) continue;
        const data = trimmed.slice(6);
        try {
          const parsed = JSON.parse(data);
          if (parsed.done) return;
          if (parsed.error) throw new Error(parsed.error);
          if (parsed.token) yield parsed.token;
        } catch (e) {
          if (e.message && !e.message.includes('JSON')) throw e;
        }
      }
    }
  },

  status: () => axios.get(`${base}/status`).then((r) => r.data.data),
};

export default aiPublicApi;
